export default class WorkHoursUtils {
  static getDayNames () {
    return [
      window.bookero.translations.$t('calendar.day1.long'),
      window.bookero.translations.$t('calendar.day2.long'),
      window.bookero.translations.$t('calendar.day3.long'),
      window.bookero.translations.$t('calendar.day4.long'),
      window.bookero.translations.$t('calendar.day5.long'),
      window.bookero.translations.$t('calendar.day6.long'),
      window.bookero.translations.$t('calendar.day7.long')
    ];
  }

  static getHoursAndMinutes () {
    let startHour = [0, 0];
    let endHour = [24, 0];
    let hours = [];

    for (let i = startHour[0]; i <= endHour[0]; i++) {
      let hPrefix = i < 10 ? '0' : '';

      if (i < endHour[0]) {
        let hourObject = {
          hour: hPrefix + i,
          minutes: []
        };

        for (let j = startHour[1]; j <= 55; j += 5) {
          let minPrefix = j < 10 ? '0' : '';
          hourObject.minutes.push(minPrefix + j);
        }

        hours.push(hourObject);
      } else if (i === endHour[0]) {
        let hourObject = {
          hour: hPrefix + i,
          minutes: []
        };

        for (let j = 0; j <= endHour[1]; j += 5) {
          let minPrefix = j < 10 ? '0' : '';
          hourObject.minutes.push(minPrefix + j);
        }

        hours.push(hourObject);
      }
    }

    return hours;
  }

  static getHoursAndMinutesWithRanges (config) {
    let days = [];

    for (let day = 0; day < 7; day++) {
      let hours = [];

      if (config['opening_hours_' + (day + 1)] === 0) {
        hours = [
          {
            hour: '00',
            minutes: ['00']
          }
        ];
      } else {
        let startHour = this.findMinimalHour(config, day);
        let endHour = this.findMaximumHour(config, day);

        for (let i = startHour[0]; i <= endHour[0]; i++) {
          let hPrefix = i < 10 ? '0' : '';

          if (typeof i === 'string' && i.length === 2) {
            hPrefix = '';
          }

          let hourObject = {
            hour: hPrefix + i,
            minutes: []
          };

          if (i === startHour[0] && i === endHour[0]) {
            for (let j = startHour[1]; j <= endHour[1]; j += 5) {
              let minPrefix = j < 10 ? '0' : '';

              if (typeof j === 'string' && j.length === 2) {
                hPrefix = '';
              }

              hourObject.minutes.push(minPrefix + j);
            }
          } else if (i === startHour[0]) {
            for (let j = startHour[1]; j <= 55; j += 5) {
              let minPrefix = j < 10 ? '0' : '';

              if (typeof j === 'string' && j.length === 2) {
                hPrefix = '';
              }

              hourObject.minutes.push(minPrefix + j);
            }
          } else if (i > startHour[0] && i < endHour[0]) {
            for (let j = 0; j <= 55; j += 5) {
              let minPrefix = j < 10 ? '0' : '';

              if (typeof j === 'string' && j.length === 2) {
                hPrefix = '';
              }

              hourObject.minutes.push(minPrefix + j);
            }
          } else if (i === endHour[0]) {
            for (let j = 0; j <= endHour[1]; j += 5) {
              let minPrefix = j < 10 ? '0' : '';

              if (typeof j === 'string' && j.length === 2) {
                hPrefix = '';
              }

              hourObject.minutes.push(minPrefix + j);
            }
          }

          hours.push(hourObject);
        }
      }

      days[day] = hours;
    }

    return days;
  }

  static findMinimalHour (config, dayIndex) {
    let value = config['opening_hours_' + (dayIndex + 1) + '_from'].split(':').map(num => parseInt(num, 10));
    let dayIndexString = (dayIndex + 1).toString();

    if (config.additional_hours[dayIndexString] && config.additional_hours[dayIndexString].length) {
      for (let i = 0; i < config.additional_hours[dayIndexString].length; i++) {
        let rangeValue = config.additional_hours[dayIndexString][i].open_from.split(':').map(num => parseInt(num, 10));

        if (rangeValue[0] < value[0] || (rangeValue[0] === value[0] && rangeValue[1] < value[1])) {
          value = rangeValue.slice();
        }
      }
    }

    return value;
  }

  static findMaximumHour (config, dayIndex) {
    let value = config['opening_hours_' + (dayIndex + 1) + '_to'].split(':').map(num => parseInt(num, 10));
    let dayIndexString = (dayIndex + 1).toString();

    if (config.additional_hours[dayIndexString] && config.additional_hours[dayIndexString].length) {
      for (let i = 0; i < config.additional_hours[dayIndexString].length; i++) {
        let rangeValue = config.additional_hours[dayIndexString][i].open_to.split(':').map(num => parseInt(num, 10));

        if (rangeValue[0] > value[0] || (rangeValue[0] === value[0] && rangeValue[1] > value[1])) {
          value = rangeValue.slice();
        }
      }
    }

    return value;
  }

  static getCompanyWorkingDays (config) {
    let days = [];

    for (let day = 1; day <= 7; day++) {
      days[day - 1] = !!config['opening_hours_' + day];
    }

    return days;
  }

  static getCompanyEmptyHours () {
    return [
      [
        [
          ['00', '00'],
          ['00', '00']
        ]
      ],
      [
        [
          ['00', '00'],
          ['00', '00']
        ]
      ],
      [
        [
          ['00', '00'],
          ['00', '00']
        ]
      ],
      [
        [
          ['00', '00'],
          ['00', '00']
        ]
      ],
      [
        [
          ['00', '00'],
          ['00', '00']
        ]
      ],
      [
        [
          ['00', '00'],
          ['00', '00']
        ]
      ],
      [
        [
          ['00', '00'],
          ['00', '00']
        ]
      ]
    ];
  }

  static getCompanyHours (config) {
    let hours = [];

    for (let day = 1; day <= 7; day++) {
      if (config['opening_hours_' + day] === 1) {
        hours[day - 1] = [
          [
            config['opening_hours_' + day + '_from'].split(':'),
            config['opening_hours_' + day + '_to'].split(':')
          ]
        ];
      } else {
        hours[day - 1] = [
          [
            ['00', '00'],
            ['00', '00']
          ]
        ];
      }
    }

    return hours;
  }
};



// WEBPACK FOOTER //
// ./src/components/helpers/WorkHoursUtils.js